import { MakeCall } from './createMakeCall';

import { KYCEntity } from './types/Kyc';

const getUserKycByUuid =
  (makeCall: MakeCall) =>
  (userId: 'me' | number = 'me', kycUuid: string) =>
    makeCall<KYCEntity>('GET', `/api/v2/user/${userId}/kyc/${kycUuid}`);
export { getUserKycByUuid };
